import { authMiddleware, mondayBoards } from "@onesolution/middlewares";
import { Box, BoxSDK } from "@onesolution/utils";
import { reportErrorToSlack } from "@onesolution/utils/reportToSlack";
import { createUserBox } from "@onesolution/utils/userSync/createUser";
import getMondayUserInfos from "@onesolution/utils/userSync/formatBodies";
import { createServerFn } from "@tanstack/react-start";
import { wrapWithUseQuery } from ".";
import { getCurrentUserDetails } from "./user";

const handler = createServerFn()
	.middleware([authMiddleware, mondayBoards])
	.handler(async ({ context }) => {
		const report: string[] = [];

		try {
			const user = await getCurrentUserDetails();
			const mondayUserId = user.id;

			if (!mondayUserId) throw "Can't find connected monday user";
			let boxUserId: string | undefined;
			try {
				boxUserId = await BoxSDK.users.findUserByMondayId(mondayUserId);
			} catch (e) {}

			if (!boxUserId) {
				const mondayUserInfos = await getMondayUserInfos({
					boardId: context.boards.users,
					pulseId: mondayUserId,
				});

				boxUserId = (await createUserBox(report, mondayUserInfos))?.id;

				if (!boxUserId) throw "Can't create box user";
			}

			await BoxSDK.users.refreshGroup(boxUserId);

			const token = await Box.getToken("user", boxUserId);

			return token;
		} catch (e) {
			await reportErrorToSlack("GET BOX TOKEN ERROR", report, e as Error);
		}
	});

export const getBoxTokenFromServer = wrapWithUseQuery("boxToken", handler);
